import { Directive, HostListener, Optional } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appAlphaNumericOnly]',
  standalone: true
})
export class AlphaNumericOnlyDirective {
  constructor(@Optional() private ngControl: NgControl) {}

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const originalValue = input.value;
    const filtered = input.value.replace(/[^a-zA-Z0-9]/g, '');
    
    // 關鍵：無論值是否改變，都要處理
    input.value = filtered;
    
    if (this.ngControl?.control) {
      const control = this.ngControl.control;
      
      // 步驟1：完全清除所有錯誤狀態
      control.setErrors(null);
      
      // 步驟2：標記為 pristine 和 untouched（重置驗證狀態）
      control.markAsPristine();
      control.markAsUntouched();
      
      // 步驟3：設定過濾後的新值
      control.setValue(filtered, { emitEvent: false });
      
      // 步驟4：重新標記為 dirty 和 touched（讓驗證生效）
      control.markAsDirty();
      control.markAsTouched();
      
      // 步驟5：執行完整的驗證流程
      control.updateValueAndValidity({ emitEvent: true });
    }
  }
}
